import PropTypes from "prop-types";
import { IconButton, InputAdornment, TextField } from "@mui/material";
import { CancelOutlined } from "@mui/icons-material";
import SearchIcon from "@mui/icons-material/Search";

const ICON_SIZE = 50;

function SearchField({ value, onChange, onSearch, onClear, placeholder, width, sx }) {
  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      onSearch?.();
    }
  };

  return (
    <TextField
      size="small"
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      onKeyDown={handleKeyDown}
      sx={{ width, ...sx }}
      InputProps={{
        endAdornment: (
          <InputAdornment
            position="end"
            sx={{
              ml: 0,
              mr: 0,
              height: "auto",
              maxHeight: "none",
            }}
          >
            {value && (
              <IconButton size="small" onClick={onClear} sx={{ p: "2px" }}>
                <CancelOutlined sx={{ fontSize: ICON_SIZE }} />
              </IconButton>
            )}
            <IconButton size="small" onClick={onSearch} sx={{ p: "2px" }}>
              <SearchIcon sx={{ fontSize: ICON_SIZE }} />
            </IconButton>
          </InputAdornment>
        ),
        sx: {
          pr: "4px !important",
          "&.MuiInputBase-adornedEnd": {
            pr: "4px !important",
          },
          "& .MuiInputAdornment-root": {
            ml: 0,
            mr: 0,
          },
          "& .MuiInputBase-input": {
            pr: "6px !important",
          },
          "& .MuiInputBase-inputAdornedEnd": {
            pr: "6px !important",
          },
        },
      }}
    />
  );
}

SearchField.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  onSearch: PropTypes.func,
  onClear: PropTypes.func,
  placeholder: PropTypes.string,
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  sx: PropTypes.object,
};

SearchField.defaultProps = {
  placeholder: "Search",
  width: 200,
  onSearch: undefined,
  onClear: undefined,
  sx: {},
};

export default SearchField;
